<table mat-table [dataSource]="dataSource" class="table">
  <!-- id Column -->
  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef class="index-column"></th>
    <td mat-cell *matCellDef="let element; let i = index">{{ i + 1 }}</td>
  </ng-container>

  <!-- Name Column -->
  <ng-container matColumnDef="lastName">
    <th
      mat-header-cell
      *matHeaderCellDef
      i18n="component tableau invitation | header"
    >
      Nom
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.lastName }}
      <small>{{ element.firstName }}</small>
    </td>
  </ng-container>

  <!-- Name Column -->
  <ng-container matColumnDef="email">
    <th
      mat-header-cell
      *matHeaderCellDef
      i18n="component tableau invitation | header"
    >
      Email
    </th>
    <td mat-cell *matCellDef="let element">{{ element.email }}</td>
  </ng-container>

  <!-- Settings Column -->
  <ng-container matColumnDef="settings">
    <th mat-header-cell *matHeaderCellDef class="settings-column"></th>
    <td mat-cell *matCellDef="let element">
      <button
        mat-raised-button
        (click)="deleteInvitation(element.id)"
        i18n="component tableau invitation | bouton"
      >
        Supprimer
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

  <tr *matNoDataRow>
    <td colspan="5">
      <p
        class="justify-center no-data"
        i18n="component tableau invitation | row no data"
      >
        Aucune invitation trouvée
      </p>
    </td>
  </tr>
</table>
